import { Grid } from '@mui/material';
import { connect, useDispatch } from 'react-redux';
import { RootState } from '../../store';
import { sortPricelistsHierarchically } from '../../utils';
import { PricelistDialog } from '../pricelist/PricelistDialog';
import { getPricelists } from '../pricelist/redux/pricelistSelectors';
import InactivatePricesButtons from './InactivatePricesButtons';
import InactivatePricesTable from './InactivatePricesTable';
import { getInactivatePricesTableSelectedPricelistIds } from './redux/inactivatePricesSelectors';
import {
    inactivatePricesTablePricelistIdsSelected,
    inactivatePriceTableCloseChoosePricelistsDialog
} from './redux/inactivatePricesSlices';

const mapStateToProps = (state: RootState) => ({
    isPricelistDialogOpen: state.inactivatePrices.ui.dialogs.isChoosePricelistsDialogOpen,
    selectedPricelistIds: getInactivatePricesTableSelectedPricelistIds(state),
    pricelists: getPricelists(state)
});

type Props = ReturnType<typeof mapStateToProps>;

const InactivatePrices = ({ isPricelistDialogOpen, selectedPricelistIds, pricelists }: Props) => {
    const dispatch = useDispatch();

    const handlePricelistDialogClosed = () => {
        dispatch(inactivatePriceTableCloseChoosePricelistsDialog());
    };

    const handlePricelistsSelected = (pricelistIds: number | number[]) => {
        const sortedPricelistIds = sortPricelistsHierarchically(pricelistIds as number[], pricelists);
        dispatch(inactivatePricesTablePricelistIdsSelected(sortedPricelistIds));
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <InactivatePricesButtons />
            </Grid>
            <Grid item xs={12} style={{ height: '82vh' }}>
                <InactivatePricesTable />
            </Grid>

            {isPricelistDialogOpen && (
                <PricelistDialog
                    handleClose={handlePricelistDialogClosed}
                    multiSelect={true}
                    selectedPricelistIds={selectedPricelistIds}
                    pricelistsSelected={handlePricelistsSelected}
                />
            )}
        </Grid>
    );
};

export default connect(mapStateToProps)(InactivatePrices);
